export default {
  mounted (el) {
    const dialog = el

    let isDragging = false
    let startX = 0
    let startY = 0
    let origLeft = 0
    let origTop = 0

    // open modal centered
    dialog.style.position = 'absolute'
    dialog.style.left = '35%'

    function onMouseDown (e) {
      isDragging = true
      startX = e.clientX
      startY = e.clientY

      const computedStyle = getComputedStyle(dialog)
      origLeft = parseFloat(computedStyle.left)
      origTop = parseFloat(computedStyle.top)

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
      e.preventDefault()
    }

    function onMouseMove (e) {
      if (!isDragging) return

      const parentHeight = document.documentElement.clientHeight
      const offsetTop = parentHeight * 0.1

      const dx = e.clientX - startX
      const dy = e.clientY - startY

      let newLeft = origLeft + dx
      let newTop = origTop + dy

      const maxLeft = document.documentElement.clientWidth - dialog.offsetWidth
      const maxTop = document.documentElement.clientHeight - dialog.offsetHeight

      newLeft = Math.max(0, Math.min(maxLeft, newLeft))
      newTop = Math.max(0, Math.max(maxTop, newTop))
      newTop = newTop - offsetTop + 40

      dialog.style.left = `${newLeft}px`
      dialog.style.top = `${newTop}px`
    }

    function onMouseUp () {
      isDragging = false
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)
    }

    function delegate (e) {
      if (e.target.closest('.modal-header')) {
        onMouseDown(e)
      }
    }
    el.addEventListener('mousedown', delegate)
    el._cleanup = () => {
      el.removeEventListener('mousedown', delegate)
    }
  },

  unmounted (el) {
    if (el._cleanup) el._cleanup()
  }
}
